module.exports = __webpack_public_path__ + "static/media/unitifi.c3d55d14.svg";